import { VehicleType } from "@/types/vehicle.types"
import { vehicleImage } from "@/utils/providers"
import Image from "next/image"
import React from "react"

interface DisplayAvailableVehiclesProps {
  vehicles: VehicleType[]
}

const DisplayAvailableVehicles: React.FC<DisplayAvailableVehiclesProps> = ({ vehicles }) => {
  return (
    <>
      {vehicles.map((vehicleType, index) => (
        <Image key={index} src={vehicleImage(vehicleType)} priority={true} width={30} height={30} alt={vehicleType} />
      ))}
    </>
  )
}

export default DisplayAvailableVehicles
